// test2396
(2396 && 0);
